import Vue from 'vue';
import axios from 'axios';

export default {
	namespaced: true,
	state: {
		token: '',
		name: '',
		surname: '', 
        login: '',
        selectedUser: null,
        errorMessage:'',
        messageSaveUserDetail:null,
	},
	getters: {
        getLogUri(state, getters, rootState, rootGetters) {
            return rootGetters['api/getApiUri'] + 'Auth/login';
        },
        getChangeUri(state, getters, rootState, rootGetters) {
            return rootGetters['api/getApiUri'] + 'Auth/modify';
        },
        getRegUri(state, getters, rootState, rootGetters) {
            return rootGetters['api/getApiUri'] + 'Auth/register';
        },
        getConfApi(state, getters, rootState, rootGetters) {
            return rootGetters['api/getConfApiUri'];
        },
        getRestApi(state, getters, rootState, rootGetters) {
            return rootGetters['api/getApiUri'];
        },
        getName (state) {
            return state.name;
        },
        getSurname (state) {
            return state.surname;
        },
        getLogin(state) {
            return state.login;
        },
        getToken(state) {
            return state.token;
        },
        getAuthUrl(state) {
            return state.authUrl;
        },
        getInfoUser(state) {
            return state.selectedUser;
        },
        getErrorMessage(state) {
            return state.errorMessage;
        },
        getMessageSaveUserDetail(state) {
            return state.messageSaveUserDetail;
        },
	},
	mutations: {
		setLogin(state, login) {
			state.login = login;
		},
		setName(state, name) {
			state.name = name;
		},
		setSurname(state, surname) {
			state.surname = surname;
		},
		setToken(state, token) {
			state.token = token;
        },
        setSelectedUser(state, data) {
			Vue.set(state, 'selectedUser', data);
        },
        setSelectedUserDetail(state, data) {
			Vue.set(state.selectedUser, 'Detail', data);
        },
        setErrorMessage(state, data) {
            state.errorMessage = data;
        },
        setMessageSaveUserDetail(state, data) {
            state.messageSaveUserDetail = data;
        },
        setAccountId(state, data) {
            state.accountId = data
        },
        clearDataUser(state) {
            state.token = '';
            state.name = '';
            state.surname = '', 
            state.login = '',
            state.selectedUser = null;
        },
        clearError(state) {
            state.errorMessage = '';
        }
	},
	actions: {
        requestUserInfo(store, login) {
			getUserByLogin(store, login);
        },
        clearUserInfo(store) {
            store.commit('clearDataUser');
        },
        performRegister(store, payload) {
            axios.post(store.getters['getRegUri'], JSON.stringify(payload), {
                headers: {
                    'Content-Type': 'application/json',
                },
                before: (d) => {
                    //console.log('before:');
                    //console.log(d);
                }
            }).then(response => {
                //console.log('performRegister - OK');
                store.commit('setName', payload.Detail.Name);
                store.commit('setSurname', payload.Detail.Surname);
                store.commit('setLogin', payload.Login);
            }, response => {
                //console.log('Error registering:');
                //console.log(response);
            });
        },
		async performLogin(store, payload) {
			await axios.post(store.getters['getLogUri'], JSON.stringify(payload), {
			    headers: {
                    'Content-Type': 'application/json',
			   	},
		        before: (d) => {
		       	    //console.log('before:');
		       	    //console.log(d);
		       	}
			}).then(response => {
			    //console.log('Obtained JWT token:');
                store.commit('setToken', response.data.token);
                store.commit('setLogin', payload.Login);
                store.commit('setErrorMessage', 'succes');
                //console.log(store.getters['getLogin'])
                store.dispatch('requestUserInfo', payload.Login);
                //console.log(store.getters['getToken']);
                
			    //broadcastingChannel.trigger('authorization.login');
			})
            .catch(error => {
                //console.log(error.response.data.message);
                store.commit('setErrorMessage', error.response.data.message);
            })
        },
        sendRegEmail(store, login) {
            axios.get(store.getters.getRestApi + 'email?login=' + login + '&type=reg')
                .catch(error => console.log(error));
        },
        async performLoginAndRegister(store, payload) {
            await axios.post(store.getters['getRegUri'], JSON.stringify(payload), {
                headers: {
                    'Content-Type': 'application/json',
                },
                  before: (d) => {
                        //console.log('before:');
                        //console.log(d);
                  }
             }).then(response => {
            store.commit('setName', payload.Detail.Name);
            store.commit('setSurname', payload.Detail.Surname);
            store.commit('setLogin', payload.User.Login);
            store.dispatch('sendRegEmail', payload.User.Login);
            return axios.post(store.getters['getLogUri'], JSON.stringify({Login:payload.User.Login,Password:payload.User.Password}), {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    before: (d) => {
                        //console.log('before:');
                        //console.log(d);
                    }
                })
            }, response => {
                        //console.log('Error registering:');
                        //console.log(response);
            })
            .then(response => {
			    //console.log('Obtained JWT token:');
                store.commit('setToken', response.data.token);
                store.commit('setLogin', payload.Login);
                store.commit('setErrorMessage', 'succes');
                //console.log(store.getters['getLogin'])
                //console.log(store.getters['getToken']);
                return(payload.Login)
			    //broadcastingChannel.trigger('authorization.login');
            })
            .catch(error => {
                //console.log(error.response.data.message);
                store.commit('clearDataUser');
                store.commit('setErrorMessage', error.response.data.message);
            })
            .then(response => {
                //console.log(payload);
                store.dispatch('requestUserInfo', payload.User.Login);
            });
        },
        async saveUserDetail(store, data) {
			let token = store.getters.getToken;
            if (!token || !token.length)
                return;
			await axios.post(store.getters['getConfApi'] + 'usermanage/updatedetail', data, {
			   	headers: {
			       'Content-Type': 'application/json',
			       'Authorization': `Bearer ${token}`
			   	},
		       	before: (d) => {
		       	}
			}).then(response => {
				//console.log(response.data);
                store.commit('setSelectedUserDetail', data);
                store.commit('setMessageSaveUserDetail','success');
			}, response => {
                store.commit('setMessageSaveUserDetail','error');
            })
        },
        async saveUserInfo(store, data) {
			let token = store.getters.getToken;
            if (!token || !token.length)
                return;
			let payload = {
				Login: data.Login,
                NewPassword: data.Password,
                currentPassword: data.currentPassword
            };
			await axios.post(store.getters['getConfApi'] + 'usermanage/update', payload, {
			   	headers: {
			       'Content-Type': 'application/json',
			       'Authorization': `Bearer ${token}`
			   	},
		       	before: (d) => {
		       	}
			}).then(response => {
                store.commit('setMessageSaveUserDetail','success');
			}, response => {
                store.commit('setMessageSaveUserDetail','error');
			});
		},
	}
}

export function isValidJwt (jwt) {  
  if (!jwt || jwt.split('.').length < 3) {
    return false
  }
  const data = JSON.parse(atob(jwt.split('.')[1]))
  const exp = new Date(data.exp * 1000) // JS deals with dates in milliseconds since epoch
  const now = new Date()
  return now < exp
}

function getUserByLogin(store, login) {
    let token = store.getters.getToken;
	if (!token || !token.length) return;
	let uri = store.getters['getConfApi'] + `usermanage/getuserdetailed?login=${encodeURIComponent(login)}`;
	axios.get(uri, {
	   	headers: {
	       'Content-Type': 'application/json',
	       'Authorization': `Bearer ${token}`
	   	},
       	before: (d) => {
       	}
	}).then(response => {
        let usr = response.data;
		if (!usr.Detail) usr.Detail = {
			Name: '',
			Surname: '',
			Patronymic: '',
			BirthDate: '',
			Status: 'Unverified',
			Phone: '',
			Email: '',
			Country: '',
			Address1: '',
			Address2: '',
			Gender: 'Unspecified'
        };
        window.localStorage['infoUser'] = JSON.stringify(response.data)
	    store.commit('setSelectedUser', response.data);
	}, response => {
	    console.log('Error getting user:');
	    console.log(response);
	});
	
}
